import React from 'react'
// import { Alert, Flex, Spin } from 'antd';
import Loader from './../Assets/images/loader.gif';


function Loading() {
    // const contentStyle = {
    //     padding: 50,
    //     // background: 'rgba(0, 0, 0, 0.05)',
    //     borderRadius: 4,
    //   };
    //   const content = <div style={contentStyle} />;
  return (
    // <Flex gap="middle" vertical>
    // <Flex gap="middle">

    //   <Spin tip="Loading" size="large">
    //     {content}
    //   </Spin>
    // </Flex>
    // </Flex>
    <div className="w-100 d-flex align-items-center justify-content-center" style={{height: '500px'}}> 
      <img src={Loader} alt="loader" style={{width: '70px'}}  />
    </div>
  )
}

export default Loading